export const baseFeatureId = 'ba5e0000-0000-0000-0000-00000000ba5e';
